<template>
  <div class="be-content">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-heading panel-heading-divider">Создание оператора курортного сбора
            </div>
            <div class="panel-body">
              <operator-form :operator="operator" ref="form" @dataIsValid="submitData"></operator-form>
              <div class="row xs-pt-15">
                <div class="col-xs-12">
                  <p class="text-center">
                    <button class="btn btn-space btn-success btn-lg " @click="validateDataForm">Создать</button>
                    <router-link :to="{name: 'operators'}">
                      <button class="btn btn-space btn-danger btn-lg">Отмена
                      </button>
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {mapGetters, mapActions} from 'vuex'
  import OperatorForm from './OperatorForm'

  export default {
    components: {OperatorForm},
    data: function () {
      return {
        operator: {
          region: null,
          name: null,
          legal_entity_form: null,
          inn: null,
          kpp: null,
          ogrn: null,
          okved: null,
          address: null,
          type: null,
          city: null
        }
      }
    },
    computed: {
      ...mapGetters(
        {
          operatorTypes: 'operatorTypes',
          legalEntityForms: 'legalEntityForms',
          regions: 'regions',
          privilegeCategories: 'privilegeCategories'
        }
      )
    },
    created () {
      this.operator.region = this.regions[0].id
    },
    methods: {
      submitData () {
        if (this.operator.legal_entity_form) {
          this.operator.legal_entity_form = this.operator.legal_entity_form['id']
        }
        this.operator.region = this.operator.region['id']
        this.operator.type = this.operator.type['id']
        let self = this
        axios.post('/api/operators/', this.operator)
          .then((response) => {
            if (response.status === 201) {
              this.getOperators()
              this.$router.push({name:'operators'})
              this.$snotify.success('Оператор создан.', 'Успешно!')
            }
          })
          .catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error('Ошибка создания оператора.'.concat(error.response.data.detail), {timeout: 10000})
            }
          })
      },
      validateDataForm: function () {
        this.$refs.form.validate()
      },
      ...mapActions([
        'getOperators',
      ])
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/operators/OperatorAdd.vue